const getAudioFileRequestBody = (text, language, rate) => {
  const voice = language === "LANG_ES" ? "Penelope" : "Danielle";
  const languageCode = language === "LANG_ES" ? "es-US" : "en-US";

  //  long-form Engine only supports English for now
  const engine = language === "LANG_ES" ? "standard" : "long-form";

  return {
    language_code: languageCode,
    playback_rate: rate || null,
    text,
    voice,
    engine,
  };
};

export default getAudioFileRequestBody;
